import { Container, ContainerType, Spacer, SpacerVariant, spacerOptionsAll } from "../components/layout"
import ImageEditor, { AspectRatio } from "../Image"
import { Repeater, types, useAdminContext } from "react-bricks/frontend"
import Typography, { TypographyElement } from "../RedesignTypography"

import React from "react"

export interface UspRedesignProps {
    spacerTop?: SpacerVariant
    spacerBottom?: SpacerVariant
    headline: TypographyElement[]
}

const UspRedesign: types.Brick<UspRedesignProps> = ({ spacerTop, spacerBottom }) => {
    const { isAdmin } = useAdminContext()

    return (
        <section className="relative" style={isAdmin ? { "--header-height": "0px" } : undefined}>
            <div className="sticky left-0 top-header h-screen-w/o-header w-full overflow-hidden">
                <div className="absolute top-0 h-full w-full md:hidden">
                    <ImageEditor
                        aspectRatio={AspectRatio["9/19"]}
                        maxWidth={1023}
                        className="h-full w-full object-cover"
                        propName="imageMobile"
                    />
                </div>
                <div className="absolute top-0 hidden h-full w-full md:block">
                    <ImageEditor
                        aspectRatio={AspectRatio["16/9"]}
                        maxWidth={2560}
                        className="h-full w-full object-cover"
                        propName="image"
                    />
                </div>
                <div className="absolute -right-[110px] top-40 w-[238px] xs:-right-[130px] xs:top-44 xs:w-[316px] sm:-right-25 sm:top-[130px] sm:w-[498px] md:-left-20 md:right-auto md:top-0 md:w-[391px] lg:w-[511px] xl:w-[543px]">
                    <div className="aspect-h-8 aspect-w-5">
                        <ImageEditor
                            aspectRatio={AspectRatio["5/8"]}
                            maxWidth={563}
                            className="h-full w-full"
                            propName="bottle"
                        />
                    </div>
                </div>
            </div>
            <Container type={ContainerType.Redesign} className="relative -mt-screen-w/o-header min-h-screen-w/o-header">
                <Spacer variant={spacerTop} />
                <div className="grid grid-cols-4 xs:grid-cols-6 gap-x-1.5 sm:grid-cols-12 sm:gap-x-3.75 lg:gap-x-5">
                    <div className="col-span-full mb-9 sm:col-span-8 sm:mb-10 md:col-start-4 lg:col-span-7 lg:col-start-4 lg:mb-15 xl:col-span-5 xl:col-start-4 xxl:col-start-1">
                        <Typography propName="headline" allowList={["S1"]} />
                    </div>
                    <ul className="col-span-3 xs:col-span-4 grid gap-y-16 sm:col-span-7 sm:gap-y-28 md:col-span-9 md:col-start-4 md:grid-cols-subgrid md:pt-20 xl:col-span-7 xl:col-start-4 xxl:col-start-1 xxl:col-span-11">
                        <Repeater propName="repeater" />
                    </ul>
                </div>
                <Spacer variant={spacerBottom} />
            </Container>
        </section>
    )
}

UspRedesign.schema = {
    name: "UspRedesign",
    label: "Redesign Usp",
    previewImageUrl: `${process.env.IMG_CDN_URL_ASSETS}/lavita.de/startseite/screenshots_bricks/UspRedesign.png`,
    repeaterItems: [
        {
            name: "repeater",
            items: [
                {
                    type: "UspItemRedesign",
                    label: "Item",
                    min: 4,
                },
            ],
        },
    ],
    sideEditProps: [
        {
            groupName: "Images",
            props: [
                {
                    name: "image",
                    label: "Image Desktop",
                    type: types.SideEditPropType.Image,
                },
                {
                    name: "imageMobile",
                    label: "Image Mobile",
                    type: types.SideEditPropType.Image,
                },
            ],
        },
        {
            groupName: "Spacer",
            props: [
                {
                    name: "spacerTop",
                    label: "Spacer Top",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptionsAll,
                        display: types.OptionsDisplay.Select,
                    },
                },
                {
                    name: "spacerBottom",
                    label: "Spacer Bottom",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptionsAll,
                        display: types.OptionsDisplay.Select,
                    },
                },
            ],
        },
    ],
    getDefaultProps: (): UspRedesignProps => ({
        spacerTop: SpacerVariant.XXL,
        spacerBottom: SpacerVariant.XXL,
        headline: [
            {
                type: "h2",
                children: [{ text: "Lorem ipsum dolor sit amet", S1: true }],
            },
        ],
    }),
}

export default UspRedesign
